import { Component, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: 'app-reprocessing-rules-dialog',
  templateUrl: './reprocessing-rules-dialog.component.html',
  standalone: true,
  imports: [MatDialogModule, MatInputModule, MatSelectModule, MatFormFieldModule, MatButtonModule, MatIconModule],
  styleUrls: ['./reprocessing-rules-dialog.component.scss']
})
export class ReprocessingRulesDialogComponent implements OnInit {

  constructor(public dialog: MatDialogRef<ReprocessingRulesDialogComponent>) {}

  ngOnInit() {
  }

}
